<template>
	<div>
		<vs-popup :active.sync="isSidebarActiveLocal" :title="$t('AddPalletItems') + ' - ' + data.palletNo"
			@cancel="clearFields" @close="clearFields">
			<StockAddNew :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"
				:companyinfo="data" />

			<vs-card v-if="!isMobile()">
				<b-col cols="12" style="padding-right: 20px">
					<b-row align-h="start">
						<b-col cols="6" align-self="center"><b-form-input v-model="searchedValue" @keyup.enter="getBarcodeList"
								id="smallInput" :placeholder="$t('Search')" />
						</b-col>
						<b-col cols="12" md="auto">
							<b-button size="sm" style="background-color: #7367F0; border-color: #7367F0;" v-on:click="getBarcodeList()">
								<Icon icon="akar-icons:search" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
								{{ $t('List') }}
							</b-button>
						</b-col>
						<b-col cols="12" md="auto">
							<b-button size="sm" style="background-color: #ffcb77; border-color: #ffcb77;" v-on:click="addNewData()">
								<Icon icon="carbon:product" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
								{{ $t('AddStock') }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</vs-card>
			<vs-card v-else>
				<b-col style="padding-right: 20px">
					<b-row align-h="start">
						<b-col cols="8" align-self="center"><b-form-input v-model="searchedValue" @keyup.enter="getBarcodeList"
								id="smallInput" :placeholder="$t('Search')" />
						</b-col>
						<b-col cols="4">
							<b-button size="sm" style="background-color: #7367F0; border-color: #7367F0;" v-on:click="getBarcodeList()">
								<Icon icon="akar-icons:search" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
								{{ $t('List') }}
							</b-button>
						</b-col>
						<b-col cols="12" style="margin-top: 15px">
							<b-button size="sm" style="background-color: #ffcb77; border-color: #ffcb77;" v-on:click="addNewData()">
								<Icon icon="carbon:product" width="20" height="20" v-b-tooltip.hover.bottom="$t('List')" />
								{{ $t('AddStock') }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</vs-card>
			<vs-card style="min-height: 250px">
				<div class="demo-inline-spacing">
					<b-form ref="form" @submit.prevent="repeateAgain">
						<b-row>
							<b-col cols="12"> </b-col>
							<b-col cols="12"> </b-col>

							<b-col cols="12">
								<b-row>
									<b-col cols="2">
										<p style="text-align: center">{{ $t('PalletNo') }}</p>
									</b-col>
									<b-col cols="6">
										<p style="text-align: center">{{ $t('StockCode') + ' / ' + $t('Barcode') }}</p>
									</b-col>

									<b-col cols="2">
										<p style="text-align: center">{{ $t('Quantity') }}</p>
									</b-col>

									<b-col cols="2"> </b-col>
								</b-row>
							</b-col>

							<b-col cols="12">

								<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new" :settings="settings"
									:key="$vs.rtl"> <b-row v-for="(item, index) in itemPalletItems" :id="item.id" :key="item.id" ref="row">
										<!-- Item Name -->
										<b-col cols="2" style="padding-right: 0">
											<b-form-group label-for="cost">
												<b-form-input v-model="item.palletNo" style="font-size: inherit" id="cost" type="text" disabled />
											</b-form-group>
										</b-col>
										<b-col cols="6" style="padding-right: 0">
											<b-form-group label-for="cost">
												<!--			<v-select color="danger" v-model="item.stockCode" :options="stock_choices" size="small"
													label="StockName" :disabled="item.disabled" autocomplete ref="selectElement"
													:name="'stockCode_' + item.id" v-validate="'required'" multiple menu-props="auto">
													<template slot="option" slot-scope="option">
														{{ option.StockCode }} / {{ option.Barcode }}
													</template>
													<template slot="item" slot-scope="data">
														{{ data.item.StockCode }} - {{ data.item.Barcode }}
													</template>
												</v-select>-->
												<vue-autosuggest :name="'barcode_' + item.id" v-validate="'required'" v-model="item.barcode"
													style="width: 100%" @click="stockCodeIndex = index" :suggestions="stock_choices"
													:get-suggestion-value="getSuggestionValue" :input-props="{
														disabled: item.disabled,
														id: 'autosuggest__input',
														class: 'form-control'
													}" @input="stockCodeInp = item.barcode; getStockListFitered()">
													<template slot-scope="{ suggestion }">
														<div class="d-flex align-items-center my-suggestion-item">
															<div class="detail ml-50 my-suggestion-item">
																<b-card-text class="mb-0">
																	{{ suggestion.item.StockCode.trim() }} /
																	{{ suggestion.item.Barcode }}
																</b-card-text>
															</div>
														</div>
													</template>
												</vue-autosuggest>


												<span class="text-danger text-sm" v-show="errors.has('barcode_' + item.id)">{{
													errors.first('barcode_' + item.id)
												}}</span>

											</b-form-group>
										</b-col>

										<b-col cols="2" style="padding-right: 0">
											<b-form-group label-for="cost">
												<b-form-input v-model="item.quantity" style="font-size: inherit" id="cost" type="text"
													:placeholder="$t('Quantity')" :disabled="item.disabled" />
											</b-form-group>
										</b-col>


										<b-col v-if="!isMobile()" style="padding-right: 0;" cols="2" class="mb-50">
											<b-row v-if="item.disabled">
												<b-col style="padding: 0; max-width: max-content;">
													<b-button variant="outline-light" size="sm" v-on:click="deletePalletItem(index)">
														<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="20" height="20" />
													</b-button>
												</b-col>

											</b-row>
											<b-row v-else>
												<b-col style="padding: 0">

													<b-button variant="outline-light" size="sm" v-on:click="addPalletItem(index)">
														<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
													</b-button>
												</b-col>
											</b-row>

										</b-col>
										<b-col v-else style="padding-right: 0;" cols="2" class="mb-50">
											<b-row v-if="item.disabled">
												<b-col style="padding: 0; max-width: max-content;">
													<b-button variant="outline-light" size="sm" v-on:click="deletePalletItem(index)">
														<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="20" height="20" />
													</b-button>
												</b-col>

											</b-row>
											<b-row v-else>
												<b-col style="padding: 0">

													<b-button variant="outline-light" size="sm" v-on:click="addPalletItem(index)">
														<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
													</b-button>
												</b-col>
											</b-row>
										</b-col>
										<!-- Remove Button -->
										<b-col cols="12" style="height: 5px"> </b-col>
									</b-row></component>

							</b-col>
						</b-row>
						<!--
						<vs-row vs-justify="flex-end">
							<b-button @click="savePalletItems()" style="background-color: #7baf7f;     border-color: #7baf7f;">
								<Icon icon="material-symbols:save-as" width="20" height="20" v-b-tooltip.hover.bottom="$t('Save')" />
								{{ $t('Save') }}
							</b-button>
						</vs-row>-->

						<!-- Row Loop -->
					</b-form>
				</div>
			</vs-card>
		</vs-popup>
	</div>
</template>
<script>
import StockAddNew from "../stock/StockAddNew.vue";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
	props: {
		isPalletItemAddNewActive: {
			type: Boolean,
			required: true
		}, data: {
			default: () => { },
		},
	},
	data() {
		return {
			sidebarData: {},
			addNewDataSidebar: false,
			stockCodeInp: "",
			stockCodeIndex: "",
			stock_choices: [],
			isMobile: function () {
				return isMobile;
			},
			searchedValue: "",
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60
			},
			itemPalletItems: [
				{
					id: 0,
					palletNo: this.data.palletNo,
					stockCode: "",
					quantity: 1,
					barcode: "",
					disabled: false,
					palletId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
				}
			],
		}
	},
	components: {
		StockAddNew,
		vSelect,
		Icon,
		VuePerfectScrollbar
	},
	watch: {
		data() {
			if (this.data.storehouse != "") {
				this.getStockListForPalletItems();
			}
		},
		isPalletItemAddNewActive(val) {
			if (this.data.storehouse != "") {
				this.getStockListForPalletItems();
			}
			if (val == true)
				if (this.data.palletItems.length > 0) {
					this.itemPalletItems = []
					this.data.palletItems.forEach((val, index) => {
						this.itemPalletItems.push({
							id: index,
							palletNo: val.palletNo,
							stockCode: val.stockCode,
							quantity: parseFloat(val.quantity),
							barcode: val.barcode,
							disabled: true,
							palletId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
						})
					});
					this.repeateAgain();
				}
				else {
					this.itemPalletItems = [
						{
							id: 0,
							palletNo: this.data.palletNo,
							stockCode: "",
							quantity: 1,
							barcode: "",
							disabled: false,
							palletId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
						}
					];
				}
			if (this.itemPalletItems.lenght < 1) val = false
			if (!val) return
			return val
		}
	},
	methods: {
		getStockListForPalletItems() {
			this.$store.dispatch("stock/listStockBarcodesForStorehouse", this.data.storehouseDetail.DepotId).then(response => {
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					this.stock_choices = this.$store.state.stock.StockBarcodes;
					this.getStockListFitered();
				} else {
					this.stock_choices = []
				}
			});
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val
		},
		addNewData() {
			this.sidebarData = {}
			this.toggleDataSidebar(true)
		},
		savePalletItems() {
			this.$root.$emit("submitPaletItems", this.data);
		},
		deletePalletItem(index) {
			this.itemPalletItems.splice(index, 1)
		},
		repeateAgain() {
			const vs = this.$vs;
			let setId = 0
			var itemLocate = this.itemPalletItems[this.itemPalletItems.length - 1];
			if (this.itemPalletItems.length == 0) setId = 0
			else setId = itemLocate.id + 1
			this.itemPalletItems.push({
				id: setId,
				palletNo: this.data.palletNo,
				stockCode: "",
				quantity: 1,
				barcode: "",
				disabled: false,
				palletId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
			});
			this.data.palletItems = this.itemPalletItems.filter(x => {
				return x.disabled == true
			});
		},
		addPalletItem(index) {
			const vs = this.$vs;
			this.$validator.validateAll().then(result => {
				if (result) {
					let filteredStock = this.itemPalletItems.filter(x => {
						return (x.barcode.toLowerCase().indexOf(this.itemPalletItems[index].barcode.toLowerCase()) >
							-1)
					})

					if (filteredStock.length == 1) {

						this.itemPalletItems[index].disabled = true
						this.repeateAgain();
						this.data.palletItems = this.itemPalletItems.filter(x => {
							return x.disabled == true
						});

					} else {
						let filteredStockId = this.itemPalletItems.findIndex(p => p.id == filteredStock[0].id)
						this.itemPalletItems[filteredStockId].quantity = parseFloat(this.itemPalletItems[filteredStockId].quantity)
						this.itemPalletItems[filteredStockId].quantity += parseFloat(this.itemPalletItems[index].quantity)

					}
				}
				else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})
		},
		getSuggestionValue(suggestion) {
			this.itemPalletItems[this.stockCodeIndex].stockCode = suggestion.item.StockCode
			this.itemPalletItems[this.stockCodeIndex].barcode = suggestion.item.Barcode
			return suggestion.item.StockCode + " - " + suggestion.item.Barcode
		},
		getStockListFitered() {
			this.stock_choices =
				[
					{
						data: this.$store.state.stock.StockBarcodes.filter(option => {
							return (
								option.StockCode.toLowerCase().indexOf(this.stockCodeInp.toLowerCase()) >
								-1 || option.Barcode.toLowerCase().indexOf(this.stockCodeInp.toLowerCase()) >
								-1
							);
						})
					}
				];
		},
		deleteBarcode(ind) {
			this.$root.$emit("deleteBarcode", this.itemPalletItems[ind]);
		},
		getBarcodeList() { },
		addBarcode(ind) {
			this.$root.$emit("submitBarcode", this.itemPalletItems[ind]);
		},
		updateBarcode(index) {
			this.$root.$emit("submitBarcode", this.itemPalletItems[index]);
		},
		clearFields() {
			if (this.data.palletItems.length > 0) {
				this.itemPalletItems = [
					{
						id: 0,
						palletNo: this.data.palletNo,
						stockCode: "",
						quantity: 1,
						barcode: "",
						disabled: false,
						palletId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
					}
				],
					this.$root.$emit("closePalletItemsPopup", false);
			}
			else {
				this.$root.$emit("closePalletItemsPopup", true);

			}

		},
	},
	created() {
		const dict = {
			custom: {
				barcode: {
					required: this.$t('barcodeRequired'),
					alpha: this.$t('barcodeRequired')
				},
				quantity: {
					required: this.$t('quantityRequired'),
					alpha: this.$t('quantityRequired')
				},
			}
		};
		Validator.localize("en", dict);
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isPalletItemAddNewActive
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
		scrollbarTag() { return this.$store.getters.scrollbarTag },
		stock: {
			get() {
				return this.$store.state.stock.Stock
			},
			set(val) {
				if (!val) {
				}
			}
		},

	},
	mounted() {
		//tables global olarak tanımlanıyor

		this.$root.$on("getStockListForPalletItems", () => {
			this.getStockListForPalletItems();
		});

	},
	beforeDestroy() {
		this.$root.$off("getStockListForPalletItems");

	},
}
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 80 - 16px - 100px - 80px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>
<style lang="scss"  >
.autosuggest-container {
	display: flex;
	justify-content: center;
	width: 280px;
}

#autosuggest {
	width: 100%;
	display: block;
}

.autosuggest__results-item--highlighted {
	background-color: rgba(51, 217, 178, 0.2);
}



.autosuggest-container {
	display: flex;
	justify-content: center;
	width: 280px;
}

#autosuggest {
	width: 100%;
	display: block;
}

.autosuggest__results-item--highlighted {
	background-color: rgba(51, 217, 178, 0.2);
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 100px - 120px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

[dir="ltr"] .autosuggest__results,
[dir="rtl"] .autosuggest__results {
	z-index: 1111111111111;
}

[dir] #autosuggest__input {
	padding: 5px !important;
	font-size: 12px;
}

#autosuggest__input {
	outline: none;
	position: relative;
	display: block;
	padding: 10px;
	width: 100%;
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.autosuggest__results-container {
	position: relative;
	width: 100%;
	z-index: 11111;
}

[dir] .autosuggest__results .autosuggest__results-item {
	padding: 7px !important;
}

[dir] .card-text:last-child {
	color: black;
	font-weight: 500;
}

.autosuggest__results {
	font-weight: 300;
	margin: 0;
	position: absolute;
	z-index: 1000000111111111111111111;
	width: 100%;
	border: 1px solid #e0e0e0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background: white;
	padding: 0px;
	max-height: 200px;
	overflow-y: scroll;
}

.autosuggest__results ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}

.autosuggest__results .autosuggest__results-item {
	cursor: pointer;
	padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results-before {
	border-top: none;
}

.autosuggest__results .autosuggest__results-before {
	color: gray;
	font-size: 11px;
	margin-left: 0;
	padding: 15px 13px 5px;
	border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
	background-color: #f6f6f6;
}
</style>